import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types";
import { Folders, Folder } from "./types";
import { escapeQueryStrValue } from "../utils/escapeQueryStrValue";
addProp(_Web, "folders", Folders);
addProp(_Web, "rootFolder", Folder, "rootFolder");
_Web.prototype.getFolderByServerRelativeUrl = function (folderRelativeUrl) {
    return Folder(this, "getFolderByServerRelativeUrl('" + escapeQueryStrValue(folderRelativeUrl) + "')");
};
_Web.prototype.getFolderByServerRelativePath = function (folderRelativeUrl) {
    return Folder(this, "getFolderByServerRelativePath(decodedUrl='" + escapeQueryStrValue(folderRelativeUrl) + "')");
};
_Web.prototype.getFolderById = function (uniqueId) {
    return Folder(this, "getFolderById('" + uniqueId + "')");
};
//# sourceMappingURL=web.js.map